<template lang="pug">
  .settings
    v-container.white.px-6(style="max-width:600px")
      div.align-center.justify-center.text-center
        //- intel-avatar.ma-2(:code="affiliate.user.avatar_code" :id="affiliate.user.id" size=80)
        div
          v-avatar(size="100")
            v-img(:src="affiliate.image ? affiliate.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
        v-btn.my-4.px-3.button-AA-tiny(color="info500" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" :loading="isLoading") {{ $t('change_photo') }}
          input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 100% !important; cursor: pointer !important;")
      v-form(ref="form")
        div.pa-2.px-4.mt-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          .label.basic600--text.text-uppercase.mb-1.mt-2 {{ $t('first_name') }}
          v-text-field.mt-2.s1.basic800--text(dense background-color="basic200" height="40" v-model="form.first_name" type="text" :placeholder="$t('first_name')" outlined :rules="rules.first_name")
          .label.basic600--text.text-uppercase.mb-1 {{ $t('last_name') }}
          v-text-field.mt-2.s1.basic800--text(dense background-color="basic200" height="40" v-model="form.last_name" type="text" :placeholder="$t('last_name')" outlined :rules="rules.last_name")
          .label.basic600--text.text-uppercase.mb-1 {{$t('phone.label')}}
          y-phone-input.my-4(v-model="form.phone")
          .label.basic600--text.text-uppercase.mt-3 {{ $t('your_language') }}
          v-select.mt-2.s1.basic800--text(v-model="language" :items="languages" item-text="name" item-value="code" outlined dense background-color="basic200" height="40" hide-details="auto")
          v-btn.my-4(color='info500' depressed dark block :loading="isLoading" @click="clickSave")
            div.button-AA-small.white--text {{ $t('update') }}

        div.pt-2.pb-4.px-4.mt-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          .s1.primary500--text.mt-1(style="") {{ $t('sign_in_methods') }}
          v-row
            v-col.py-0.px-3.grow.pr-0(style="margin-right:-2px" @click="addOrChangePhone")
              v-text-field.mt-4.p1.basic500--text( solo flat background-color="basic200"    height="40" color="primary" v-model="user.auth_phone" type="tel" hide-details disabled outlined dense style="border-top-right-radius:0px; border-bottom-right-radius:0px")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('phone_number') }}
                  v-icon(v-if="user.auth_phone" color="green lighten-1" slot="append") mdi-check-circle
            v-col.pa-0.mt-4.pl-0.pr-3.shrink
              v-btn.info500.button-AA-small.white--text(@click="addOrChangePhone" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ user.auth_phone ? $t('change') : $t('add')}}
          v-row.mt-2
            v-col.py-0.pl-3.grow.pr-0(style="margin-right:-2px")
              v-text-field.mt-4.p1.basic500--text(solo flat background-color="basic200"    height="40" color="primary" v-model="user.email" type="email" label="Email address" hide-details disabled outlined dense style="border-top-right-radius:0px; border-bottom-right-radius:0px")
                template(v-if="user.email")
                  v-icon(v-if="user.email_verified" color="green lighten-1" slot="append") mdi-check-circle
                  v-icon(v-else color="red lighten-1" slot="append") mdi-close-circle
            v-col.pa-0.mt-4.pr-3.shrink.pl-0
              template(v-if="user.email")
                v-btn.info500.button-AA-small.white--text(height=40 depressed color="accent" @click="verifyOrChangeEmail" style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ user.email_verified ? $t('change') : $t('verify') }}
              template(v-else)
                v-btn.info500.button-AA-small.white--text(height=40 depressed color="accent" @click="addEmail" style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ $t('add') }}
        
        div.my-4.pa-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          div.s1.primary-500--text {{ $t('banks_details') }}
          div.caption.c1.primary400--text.mb-6 {{ $t('banks_details_desc') }}
          template(v-if="affiliate.bank && affiliate.bank_account")
            v-card(outlined)
              v-simple-table
                thead
                  tr
                    th {{ $t('bank') }}
                    th.px-0(colspan="2") {{ $t('account_number') }}
                tbody
                  tr
                    td {{ banks.filter(f => f.code === affiliate.bank)[0].name || '' }}
                    td.px-0 {{ affiliate.bank_account }}
                    td
                      v-btn(icon small)
                        eva-icon(name="edit-outline" :fill="$vuetify.theme.themes[$theme].info500" height="18" width="18" @click="addBankDialog = true")
          template(v-else)
            v-btn.button-AA-small.white--text(height=32 block small depressed color="info500" @click="addBankDialog = true") {{ $t('add_bank_details') }}
        
        div.my-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          div.d-flex.align-center.px-4.pt-4.pb-2
            div.s1.basic1000--text {{ $t('personal_details') }}
            v-spacer
            v-btn.px-0(color='transparent' text :ripple="false" @click="addAddressDialog = true" small)
              eva-icon(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="17")
              .button-Aa-small.textColorAccent--text {{ $t('edit_details') }}
          template(v-if="affiliate.address")
            v-divider.basic400.mt-2
            .address.pa-4(v-if="affiliate.address")
              div.p2.primary500--text {{ affiliate.address.address_1 }},
              div.p2.primary500--text {{ affiliate.address.address_2 }},
              template(v-if="affiliate.address.area")
                div.p2.primary500--text {{ affiliate.address.postcode }}, {{ affiliate.address.area }},
                div.p2.primary500--text {{ affiliate.address.suburb }}, {{ affiliate.address.city }},
              div.p2.primary500--text(v-else) {{ affiliate.address.postcode }}, {{ affiliate.address.city }},              
              div.p2.primary500--text {{ affiliate.address.state }}, {{ affiliate.address.country }}.
              div.p2.primary500--text.mt-2 {{ affiliate.address.phone }}

        .modal
          change-avatar(v-if="showChangeAvatarDialog" :open.sync="showChangeAvatarDialog" :code.sync="affiliate.user.avatar_code" :user="user.id")
          change-phone(v-if="changePhoneDialog" :showModal.sync="changePhoneDialog")
          verify-email(v-if="verifyEmailDialog" :showModal.sync="verifyEmailDialog" @changeEmail="changeEmail")
          change-email(v-if="changeEmailDialog" :showModal.sync="changeEmailDialog")
          add-email(v-if="addEmailDialog" :showModal.sync="addEmailDialog")
          add-phone(v-if="addPhoneDialog" :showModal.sync="addPhoneDialog")
          add-bank(v-if="addBankDialog" :open.sync="addBankDialog" :propAffiliate.sync="affiliate")
          add-address(v-if="addAddressDialog" :open.sync="addAddressDialog" :propAffiliate.sync="affiliate")
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'
import ChangeAvatar from '@/components/dialogs/account/ChangeAvatar.vue'
import AddEmail from '@/components/dialogs/account/AddEmail.vue'
import VerifyEmail from '@/components/dialogs/account/VerifyEmail.vue'
import ChangeEmail from '@/components/dialogs/account/ChangeEmail.vue'
import AddPhone from '@/components/dialogs/account/AddPhone.vue'
import ChangePhone from '@/components/dialogs/account/ChangePhone.vue'
import AddBank from '@/components/dialogs/affiliate/AddBank.vue'
import AddAddress from '@/components/dialogs/affiliate/AddAddress.vue'
// import AddAddressId from '@/components/dialogs/affiliate/AddAddressId.vue'
import { resizeImage } from '@/utils'

export default {
  name: 'AffiliateProfile',
  components: { IntelAvatar, ChangeAvatar, AddEmail, VerifyEmail, ChangeEmail, AddPhone, ChangePhone, AddBank, AddAddress },
  props: ['propAffiliate'],
  data: () => ({
    form: {
      first_name: '',
      last_name: '',
      phone: '',
    },
    showChangeAvatarDialog: false,
    addEmailDialog: false,
    verifyEmailDialog: false,
    changeEmailDialog: false,
    addBankDialog: false,
    addAddressDialog: false,
    addPhoneDialog: false,
    changePhoneDialog: false,
    isLoading: false,
    resizeImageFileUrl: null,
    resizeImageFile: null,
    language: null,
    languages: [
      { name: 'English', code: 'en' },
      { name: 'Bahasa Indonesia', code: 'id' },
    ],
    banks: [
      { code: 'PHBMMYKL', name: 'Affin Bank' },
      { code: 'BPMBMYKL', name: 'Agrobank' },
      { code: 'MFBBMYKL', name: 'Alliance Bank' },
      { code: 'RJHIMYKL', name: 'Al Rajhi Banking' },
      { code: 'ARBKMYKL', name: 'AmBank' },
      { code: 'BIMBMYKL', name: 'Bank Islam' },
      { code: 'BKRMMYKL', name: 'Bank Rakyat' },
      { code: 'BMMBMYKL', name: 'Bank Muamalat' },
      { code: 'BSNAMYK1', name: 'Bank Simpanan Nasional' },
      { code: 'CIBBMYKL', name: 'CIMB' },
      { code: 'CITIMYKL', name: 'Citibank' },
      { code: 'HLBBMYKL', name: 'Hong Leong Bank' },
      { code: 'HBMBMYKL', name: 'HSBC Bank' },
      { code: 'KFHOMYKL', name: 'Kuwait Finance House' },
      { code: 'AFBQMYKL', name: 'MBSB Bank' },
      { code: 'MBBEMYKL', name: 'Maybank' },
      { code: 'OCBCMYKL', name: 'OCBC Bank' },
      { code: 'PBBEMYKL', name: 'Public Bank' },
      { code: 'RHBBMYKL', name: 'RHB Bank' },
      { code: 'SCBLMYKX', name: 'Standard Chartered Bank' },
      { code: 'UOVBMYKL', name: 'United Overseas Bank' }
    ],
    rules: {
      first_name: [
        v => !!v || 'First name is required'
      ],
      last_name: [
        v => !!v || 'Last name is required'
      ],
      email: [
        v => !!v || 'E-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      password: [
        v => !!v || 'Password is required'
      ],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ]
    }
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    phoneSanitized () {
      let phone = this.form.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
  },
  mounted () {
    this.form.first_name = this.affiliate.first_name
    this.form.last_name = this.affiliate.last_name
    this.form.phone = this.affiliate.phone
    if (this.affiliate.image && this.affiliate.image.file) {
      this.resizeImageFileUrl = this.affiliate.image.file
    }
    this.language = this.lang
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.$axios.patch(`/partners/${this.affiliate.id}/`, this.form)
        .then(resp => {
          this.affiliate = resp.data
          this.showMessage(['success', this.$t('success_message.profile_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      this.$store.commit('language/setLanguage', this.language)
    },
    addOrChangePhone () {
      if (this.user.auth_phone) {
        this.changePhoneDialog = true
      } else {
        this.addPhoneDialog = true
      }
    },
    addEmail () {
      this.addEmailDialog = true
    },
    verifyOrChangeEmail () {
      if (this.user.email_verified) {
        this.changeEmailDialog = true
      } else {
        this.verifyEmailDialog = true
      }
    },
    changeEmail () {
      this.verifyEmailDialog = false
      this.changeEmailDialog = true
    },
    async onFileChange (e) {
      this.isLoading = true
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'company_logo.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
      setTimeout(() => this.saveImage(), 1500);
    },
    saveImage(){
      if (!this.resizeImageFile) {
        this.showMessage(['error', this.$t('error_message.no_image_found')])
        return
      }
      var params = new FormData()
      params.append('image', this.resizeImageFile)
      this.axios.patch(`/partners/${this.affiliate.id}/`, params)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.image_updated')])
          this.fetchPartner()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_upload_image')])
        })
    },
    fetchPartner () {
      this.isLoading = true
      this.$axios.get('/partners')
        .then(resp => {
          this.affiliate = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>

<i18n>
{
  "en": {
    "phone": {
      "label": "Mobile Phone",
      "placeholder": "Phone Number"
    },
    "first_name": "First name",
    "last_name": "Last name",
    "sign_in_methods": "Sign in methods",
    "phone_number": "Phone number",
    "banks_details": "Banks details",
    "banks_details_desc": "Add bank details for commission payment.",
    "bank": "Bank",
    "account_number": "Account Number",
    "add_bank_details": "Add bank details",
    "personal_details": "Personal Details",
    "edit_details": "Edit details"
  },
  "id": {
    "phone": {
      "label": "Nomor Telepon",
      "placeholder": "Nomor Telepon"
    },
    "first_name": "Nama depan",
    "last_name": "Nama belakang",
    "sign_in_methods": "Metode sign-in",
    "phone_number": "Nomor Telepon",
    "banks_details": "Rincian bank",
    "banks_details_desc": "Tambahkan detail bank untuk pembayaran komisi.",
    "bank": "Bank",
    "account_number": "Nomor Akun",
    "add_bank_details": "Tambahkan detail bank",
    "personal_details": "Data pribadi",
    "edit_details": "Edit Detail"
  }
}
</i18n>
